import { ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router';
import './style.css';
// import { Header } from '../components/Header';
import { Footer } from '../components/footer';
import { PackageWidget } from '../components/PackageWidget/PackageWidget';
import { Paths } from '../routes/paths';
import  BackButton  from '../components/BackButton';
import { UserHeader } from '../components/UserHeader';

type LayoutProps = {
  children: ReactNode;
};

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  
  // Hide package widget on home page
  const showPackageWidget = !location.pathname.includes(Paths.home);
const isBackButtonHidden =
  location.pathname === `/${Paths.analystArea}` ||
  location.pathname === `/${Paths.home}`;

  
    console.log("pathname:", location.pathname);
console.log("analystArea:", Paths.analystArea);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      backgroundImage: 'url("/Images/view1.png")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'repeat-y',
      backgroundAttachment: 'scroll'
    }}>
      {/* <Header /> */}
      {(location.pathname !== `/${Paths.home}`&& <UserHeader />)}
      
      

      <main style={{ flex: 1, overflowY: 'auto' }}>
        {!isBackButtonHidden && (
    <BackButton />
)}

       {/* {location.pathname !== Paths.home && <BackButton />} */}
        <Outlet />
      </main>

      <Footer />
      
      <PackageWidget show={showPackageWidget} />
    </div>
  );
};
